export default __webpack_public_path__ + "static/media/img-0215-mexico-half-face.921aca62.png";